import React from 'react';
import { type ServerUiComponent } from '@features/server-ui';

import { type SemanticBelowGatePayload } from '../../types';
import { type GhostMetric,GhostTile } from '../GhostTile';

/**
 * SemanticBelowGateTile — the SDUI domain component for the `semantic_below_gate`
 * domain_payload. Reads the typed below-gate summary (`component.data`) and
 * renders the single GhostTile listing the names of metrics under their sample
 * gate. Renders nothing when the list is empty (GhostTile returns null).
 */
export const SemanticBelowGateTile: React.FC<{ component: ServerUiComponent }> = ({
  component,
}) => {
  const data = component.data as unknown as SemanticBelowGatePayload | undefined;
  const metrics: GhostMetric[] = (data?.metrics ?? []).map(m => ({
    name: m.display_name,
    applicable: m.n ?? undefined,
    threshold: m.min_denominator ?? undefined,
  }));
  return <GhostTile metrics={metrics} />;
};
